import NotificationTemplateTag from "./components/Tags"
import List from "./components/List"
import Form from "./components/Form"

let module = "notificationtemplates"

export default [
  {
    path: "notificationtemplates",
    component: List,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "notificationtemplates/tags",
    component: NotificationTemplateTag,
    meta: { module: module, permissions: ["all"] }
  },
  {
    path: "notificationtemplates/edit/:id",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["notificationtemplate-edit"] }
  }
]
